import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';
import Statement from "./statement";
import InvestorWithdrawals from "./withdrawals";
import InvestorDeposits from "./deposits";
import WalletJournalButton from "./walletJournalButton";
import {connect} from "react-redux";
import Paper from '@material-ui/core/Paper';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
    sectionHeader:{
        position:'absolute',
        top:0,
        left:0,
        backgroundColor:'white',
        width: '100%',
        zIndex: 100,
        paddingTop: '5px',
    },
    tabs:{
        display:'inline-block',
        width:'100%',
        borderBottom:'2px solid #6a94ff',
        marginLeft:0,
        paddingLeft:0,

        '& li':{
            display:'inline-block',

            '& button':{
                margin:'1px',
                padding:'6px 12px',
                backgroundColor:'#383c42',
                color:'white'
            },
            '& button:hover':{
                backgroundColor:'#6a94ff',
            },
            '& button.active':{
                backgroundColor:'#6a94ff',
            }
        }
    },
    flex: {
        flex: 1,
    },
});

class Statements extends Component {
    state={
        activeTab:'usd'
    };

    changeTab = (e) => {
        this.setState({
            activeTab:e.target.id
        })
    }

    render() {
        const {classes} = this.props;

        return (
            <div className={'flex-col flex h-full here'}>

                <div className={'flex'} style={{height:'35%'}} >
                    <Paper className={'flex-1'} style={{position:'relative', margin:5}}>
                        <AppBar position="static" elevation={0} color={"default"}>
                            <Toolbar>
                                <Typography variant="title" color="inherit" className={classes.flex}>
                                    Withdrawals
                                </Typography>
                            </Toolbar>
                        </AppBar>

                        <div style={{overflow:'auto',height:'100%',padding: 5}}>
                            <InvestorWithdrawals investor = {this.props.investor} currency={this.state.activeTab}/>
                        </div>
                    </Paper>

                    <Paper className={'flex-1'} style={{position:'relative', margin:5}}>
                        <AppBar position="static" elevation={0} color={"default"}>
                            <Toolbar>
                                <Typography variant="title" color="inherit" className={classes.flex}>
                                    Deposits
                                </Typography>
                            </Toolbar>
                        </AppBar>
                        <div style={{overflow:'auto',height:'100%',padding: 5}}>
                            <InvestorDeposits investor = {this.props.investor} currency={this.state.activeTab}/>
                        </div>
                    </Paper>
                </div>

                <div className={'flex mr-1'} style={{height:'65%',overflow:'auto'}}>
                    <Paper className={'flex-1'} style={{position:'relative', margin:5}}>
                        <AppBar position="static" elevation={0} color={"default"}>
                            <Toolbar>
                                <Typography variant="title" color="inherit" className={classes.flex}>
                                    Statements
                                </Typography>
                                {(this.props.user.role.includes('super') || this.props.user.role.includes('accounting')) &&
                                  <WalletJournalButton investor = {this.props.investor} />
                                }
                            </Toolbar>
                        </AppBar>

                    <div className={classes.sectionHeader} style={{position:'relative',padding: '5px', marginTop:'6px'}}>
                        <ul className={classes.tabs}>
                            <li><button className={(this.state.activeTab === 'usd') ? 'active' : ''} onClick={this.changeTab} id={'usd'}>USD</button></li>
                            <li><button className={(this.state.activeTab === 'ang' || this.state.activeTab === 'xcg') ? 'active' : ''} onClick={this.changeTab} id={'ang'}>XCG</button></li>
                            <li><button className={(this.state.activeTab === 'eur') ? 'active' : ''} onClick={this.changeTab} id={'eur'}>EUR</button></li>
                            <li><button className={(this.state.activeTab === 'gbp') ? 'active' : ''} onClick={this.changeTab} id={'gbp'}>GBP</button></li>
                            <li><button className={(this.state.activeTab === 'ipo') ? 'active' : ''} onClick={this.changeTab} id={'ipo'}>IPO</button></li>
                        </ul>
                    </div>
                    <div style={{overflow:'auto', height: 'calc(100% - 117px)'}}>
                        <Statement investor = {this.props.investor} currency={this.state.activeTab}/>
                    </div>
                    </Paper>
                </div>

            </div>
        )
    }
}

function mapStateToProps({ fuse, auth }) {
    return {
        user: auth.user
    }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(connect(mapStateToProps)(Statements))));
